import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Cliente, DataClientes, DataSucursales, sucursal } from '../ABC/utils/models/ABC';
import { ABCService } from '../ABC/utils/services/ABC.service';
import { FiltrosComponent } from '../../core/components/filtros/filtros.component';
import { PeriodoInventarioService } from '../../services/inventario/periodo/periodo-inventario.service';
import { ReporteGarantiasService, DataTiposGarantia, TipoGarantia, Tecnico } from '../../services/reportes/reporte-garantias/reporte-garantias.service';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';

import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SortEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import Swal from 'sweetalert2';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-reporte-garantias',
  templateUrl: './reporte-garantias.component.html',
  styleUrls: ['./reporte-garantias.component.scss']
})
export class ReporteGarantiasComponent implements OnInit {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('dt') dt: Table;
  @ViewChild('error') public readonly modalError!: SwalComponent;

  public formGarantias: FormGroup;
  public sucursales: sucursal[] = [];
  public sucursalesSeleccionadas: sucursal[] = [];
  public clientes: Cliente[] = []
  public clientesSeleccionados: Cliente[] = [];
  public almacenesSeleccionados: any[] = [];
  public almacenesTmp: any[] = [];
  public almacenes: any[] = [];
  public tiposGarantia: TipoGarantia[] = [];
  public tiposGarantiaSeleccionados: TipoGarantia[] = [];
  public tecnicos: Tecnico[] = [];
  public tecnicosSeleccionados: Tecnico[] = [];

  public tiposGarantiaFiltro: TipoGarantia[] = [];
  public progressAlmacen: boolean = false;

  garantias = [];
  garantiasEstadoInicial: any[];
  garantiasDataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  isSorted: boolean = null;
  // Define las columnas de la tabla y su orden
  displayedColumns: string[] = []

  public dataSend: any = {
    empresaID: environment.empresaId,
    selectAllSucursales: false,
    sucursales: [],
  }

  public load: boolean = false;
  public maxDate: Date;

  mensajeError: string = '';
  detalleError: any;
  mostrarDetalle: boolean = false;
  columnas = [];

  constructor(
    private abcService: ABCService,
    private formBuilder: FormBuilder,
    private matDialog: MatDialog,
    private periodoInventarioService: PeriodoInventarioService,
    private garantiasService: ReporteGarantiasService,
    private spinner: NgxSpinnerService,
  ) {
    this.spinner.show('spinner-reporte-garantias')
  }

  ngOnInit(): void {
    this.buildForm();
    this.setFecha();
    this.getSucursales();
    this.getAlmacenes(0);
    this.getClientesAbc();
    this.getTiposGarantia();
    this.getTecnicos();
  }

  ngAfterContentInit() {
    this.spinner.hide('spinner-reporte-garantias');
  }

  setFecha() {
    this.maxDate = new Date();
    this.formGarantias.get('fechaInicio').setValue(new Date().toISOString());
    this.formGarantias.get('fechaFin').setValue(new Date().toISOString());
  }

  public getInputValue(control: string) {
    return this.formGarantias.get(control);
  }

  public modalClientes(opcion: number) {
    let list = [];
    let listCheck = [];
    switch (opcion) {
      case 3:
        list = this.clientes;
        listCheck = this.clientesSeleccionados;
        break;
      case 6:
        list = this.sucursales;
        listCheck = this.sucursalesSeleccionadas;
        break;
      case 7:
        list = this.almacenes;
        listCheck = this.almacenesSeleccionados;
        break;
      case 8:
        list = this.tiposGarantia;
        listCheck = this.tiposGarantiaSeleccionados;
        break;
      case 9:
        list = this.tecnicos;
        listCheck = this.tecnicosSeleccionados;
        break;
    }
    const dialogRef = this.matDialog.open(FiltrosComponent, {
      disableClose: true,
      width: '28%',
      data: {
        opcion,
        lista: list,
        listaCheck: listCheck,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      switch (opcion) {

        case 3: // Clientes
          this.clientesSeleccionados = result;

          this.dataSend.selectAllClientes =
            this.clientesSeleccionados.length == this.clientes.length;
          //this.dataSend.clientes = this.clientesListSelected;

          this.dataSend.clientes = this.dataSend.selectAllClientes
            ? []
            : this.clientesSeleccionados;
          const cliente =
            this.clientesSeleccionados.length > 0
              ? this.clientesSeleccionados[0].Nombre.slice(0, 20)
              : '';
          const clientes2 =
            this.clientesSeleccionados.length > 1
              ? ' (+' +
              (this.clientesSeleccionados.length - 1) +
              ' ' +
              (this.clientesSeleccionados.length === 2
                ? 'Cliente'
                : 'Clientes') +
              ')'
              : '';
          if (this.clientesSeleccionados.length > 0) {
            this.getInputValue('clientesAbc').setValue(
              cliente + ' ' + clientes2
            );
          } else {
            this.getInputValue('clientesAbc').setValue('');
          }
          break;
        case 6: // sucursales
          this.sucursalesSeleccionadas = result;

          this.dataSend.selectAllSucursales =
            this.sucursalesSeleccionadas.length == this.sucursales.length;

          this.dataSend.sucursales = this.dataSend.selectAllSucursales
            ? []
            : this.sucursalesSeleccionadas;
          const sucursales =
            this.sucursalesSeleccionadas.length > 0
              ? this.sucursalesSeleccionadas[0].Nombre.slice(0, 20)
              : '';
          const sucursales2 =
            this.sucursalesSeleccionadas.length > 1
              ? ' (+' +
              (this.sucursalesSeleccionadas.length - 1) +
              ' ' +
              (this.sucursalesSeleccionadas.length === 2
                ? 'Sucursal'
                : 'Sucursales') +
              ')'
              : '';
          if (this.sucursalesSeleccionadas.length > 0) {
            this.getInputValue('sucursales').setValue(
              sucursales + ' ' + sucursales2
            );

            this.almacenes = [];
            this.sucursalesSeleccionadas.forEach((sucursal: sucursal) => {
              this.almacenesTmp.forEach((almacen: any) => {
                if (almacen.Sucursal == sucursal.SucursalId) {
                  this.almacenes.push({
                    id: almacen.AlmacenID,
                    Nombre: almacen.NombreAlmacen,
                  });
                }
              });
            });
          } else {
            this.getInputValue('sucursales').setValue('');
            this.almacenes = [];
          }

          break;
        case 7: // Almacenes
          this.almacenesSeleccionados = result;

          this.dataSend.selectAllAlmacenes =
            this.almacenesSeleccionados.length == this.almacenes.length;
          //this.dataSend.almacenes = this.almacenesSeleccionados;
          this.dataSend.almacenes = this.dataSend.selectAllAlmacenes
            ? []
            : this.almacenesSeleccionados;
          const almacen =
            this.almacenesSeleccionados.length > 0
              ? this.almacenesSeleccionados[0].Nombre.slice(0, 20)
              : '';
          const almacen2 =
            this.almacenesSeleccionados.length > 1
              ? ' (+' +
              (this.almacenesSeleccionados.length - 1) +
              ' ' +
              (this.almacenesSeleccionados.length === 2
                ? 'Almacén'
                : 'Almacenes') +
              ')'
              : '';
          if (this.almacenesSeleccionados.length > 0) {
            this.getInputValue('almacen').setValue(almacen + ' ' + almacen2);
          } else {
            this.getInputValue('almacen').setValue('');
          }
          break;
        case 8: // TipoDeGarantia
          this.tiposGarantiaSeleccionados = result;

          this.dataSend.selectAllTiposGarantia =
            this.tiposGarantiaSeleccionados.length == this.tiposGarantia.length;

          this.dataSend.tiposGarantia = this.dataSend.selectAllTiposGarantia
            ? []
            : this.tiposGarantiaSeleccionados;
          const tipoGarantia =
            this.tiposGarantiaSeleccionados.length > 0
              ? this.tiposGarantiaSeleccionados[0].Descripcion.slice(0, 20)
              : '';
          const tipoGarantia2 =
            this.tiposGarantiaSeleccionados.length > 1
              ? ' (+' +
              (this.tiposGarantiaSeleccionados.length - 1) +
              ' ' +
              (this.tiposGarantiaSeleccionados.length === 2
                ? 'Tipo de Garantía'
                : 'Tipos de Garantía') +
              ')'
              : '';
          if (this.tiposGarantiaSeleccionados.length > 0) {
            this.getInputValue('tiposGarantia').setValue(
              tipoGarantia + ' ' + tipoGarantia2
            );
          } else {
            this.getInputValue('tiposGarantia').setValue('');
          }
          break;
        case 9: // Tecnicos
          this.tecnicosSeleccionados = result;

          this.dataSend.selectAllTecnicos =
            this.tecnicosSeleccionados.length == this.tecnicos.length;

          this.dataSend.tecnicos = this.dataSend.selectAllTecnicos
            ? []
            : this.tecnicosSeleccionados;
          const tecnico =
            this.tecnicosSeleccionados.length > 0
              ? this.tecnicosSeleccionados[0].Tecnico.slice(0, 20)
              : '';
          const tecnico2 =
            this.tecnicosSeleccionados.length > 1
              ? ' (+' +
              (this.tecnicosSeleccionados.length - 1) +
              ' ' +
              (this.tecnicosSeleccionados.length === 2
                ? 'Técnico'
                : 'Técnicos') +
              ')'
              : '';
          if (this.tecnicosSeleccionados.length > 0) {
            this.getInputValue('tecnicos').setValue(
              tecnico + ' ' + tecnico2
            );
          } else {
            this.getInputValue('tecnicos').setValue('');
          }
          break;
      }
    });
  }

  private getSucursales() {
    this.abcService.getSucursales().subscribe((res: DataSucursales) => {
      this.sucursales = res.sucursales;
    });
  }

  private getClientesAbc() {
    this.getInputValue('clientesAbc').disable();
    this.abcService.getClientesAbcDos().subscribe((res: DataClientes) => {
      this.clientes = res.clientes;
      this.getInputValue('clientesAbc').enable();
    });
  }

  getAlmacenes = (sucursal: number) => {

    this.formGarantias.get('almacen').setValue('');
    this.progressAlmacen = true;
    this.periodoInventarioService
      .almacen(sucursal)
      .then((res) => {
        this.almacenesTmp = res.response;

        this.progressAlmacen = false;
      })
      .catch((error) => {
        Swal.fire({
          type: 'error',
          title: 'Error',
          text: error.message,
          footer: 'Comunícate para resolver el problema',
        });
        this.progressAlmacen = false;
      });
  };

  private getTiposGarantia() {
    this.garantiasService.getTiposGarantia().subscribe((res: DataTiposGarantia) => {
      this.tiposGarantia = res.data;
      this.tiposGarantia.forEach(tipoGarantia => {
        tipoGarantia.Descripcion = this.capitalizarFrase(tipoGarantia.Descripcion);
      });
    })
  }

  private getTecnicos() {
    this.garantiasService.getTecnicos().subscribe((res: DataTiposGarantia) => {
      this.tecnicos = res.data;
      this.tecnicos.forEach(tecnico => {
        tecnico.Tecnico = this.capitalizarFrase(tecnico.Tecnico);
      });
    })
  }

  getReporte() {
    const fechaInicio = new Date(this.formGarantias.get('fechaInicio').value).toISOString().slice(0, 10);
    const fechaFin = new Date(this.formGarantias.get('fechaFin').value).toISOString().slice(0, 10);

    if (fechaInicio > fechaFin) {
      Swal.fire({
        type: 'warning',
        title: 'Fechas incorrectas',
        text: 'La fecha inicio no puede ser mayor a la fecha final.',
        confirmButtonText: 'Aceptar'
      });
      return;
    } else {
      this.dataSend.fechaInicio = fechaInicio;
      this.dataSend.fechaFin = fechaFin;
    }

    this.spinner.show('spinner-reporte-garantias');
    this.garantiasService.getGarantias(this.dataSend).subscribe((res) => {
      const respuesta = res;
      console.log("respuesta: ", respuesta)
      if (res.error) {
        this.spinner.hide('spinner-reporte-garantias');
        this.mensajeError = res.message;
        this.detalleError = JSON.parse(res.detalle);
        this.modalError.show()
        return;
      }
      this.displayedColumns = Object.keys(respuesta.NombreColumnas[0]);
      console.log(this.displayedColumns)
      this.columnas = this.displayedColumns.map(field => ({ field }));
      this.garantias = respuesta.ReporteOts;
      this.garantiasDataSource = new MatTableDataSource(this.garantias);
      this.garantiasEstadoInicial = [...this.garantias]
      this.garantiasDataSource.paginator = this.paginator;
      this.garantiasDataSource.sort = this.sort;
      this.spinner.hide('spinner-reporte-garantias');
    })
  }

  buildForm() {
    const hoy = new Date();
    this.formGarantias = this.formBuilder.group({
      clientesAbc: new FormControl('', [Validators.required]),
      sucursales: new FormControl('', [Validators.required]),
      almacen: ['', [Validators.required]],
      tiposGarantia: ['', [Validators.required]],
      tecnicos: ['', Validators.required],
      fechaInicio: [''],
      fechaFin: ['']
    });
  }

  customSort(event: SortEvent) {
    if (this.isSorted == null || this.isSorted === undefined) {
      this.isSorted = true;
      this.sortTableData(event);
    } else if (this.isSorted == true) {
      this.isSorted = false;
      this.sortTableData(event);
    } else if (this.isSorted == false) {
      this.isSorted = null;
      this.garantias = [...this.garantiasEstadoInicial];
      this.dt.reset();
    }
  }

  sortTableData(event: SortEvent) {
    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;
      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;

      return event.order * result;
    });
  }

  exportarExcel() {
    // Enviar this.dt.filteredValue a el servicio de exportar si se utiliza la tabla de primeng
    // console.log(this.dt.filteredValue)
    this.garantiasService.exportarGarantiasAExcel(
      this.garantias, this.displayedColumns
    )
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.dt.filteredValue);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Garantias");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  filtrarTabla(event: any, campo: string) {
    this.dt.filter(event.target.value, campo, 'contains')
    //console.log(this.dt.filteredValue)
  }

  capitalizarFrase(str: string) {
    var newStr = str.toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    return newStr;
  }

  mostrarDetalles() {
    this.mostrarDetalle = !this.mostrarDetalle;
    /* const preElement = document.getElementById('errorDetails');
    if (preElement) {
      // Toggle the display of the pre element
      preElement.style.display = preElement.style.display === 'none' ? 'block' : 'none';
    } */
  }

  cerrarModalError() {
    this.modalError.nativeSwal.close();
  }

}